import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { DownloadImageDialog } from '../../../components'


const mapStateToProps = (state, ownProps) => {
  const { open, image } = state.downloadImageDialog
  return ({
    open,
    image,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { elementId } = ownProps
  return ({
    handleClose: () => { 
      dispatch(actions.downloadImageDialog.close())
    },
    handleEnter: () => {
      ownProps.onEnter()
    },
    handleEntered: () => {
      dispatch(actions.lib.requestCreateBoardImage(elementId))
    },
    handleExited: () => {
      dispatch(actions.lib.clearDownloadImage())
      ownProps.onExited()
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DownloadImageDialog)



// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/DownloadImageDialog.js